<template>
  <div>
    <div relative v-if="hasLocation && selectedDistrict">
      <MapFeature
        bg-stone-100
        bg-opacity-50
        :location="location"
        :bbox="selectedDistrict.bbox"
        :source="source"
        :layers="schoolsLayers"
        :lineLayer="selectedLayer.lineLayer"
        :labelLayer="selectedLayer.labelLayer"
        :labelField="selectedLayer.labelField"
        :featureId="props.schoolDistrict.map((d) => d.id)"
        @markerMove="emit('markerMove', $event)"
      />
      <Toggle class="my-2 sm:(absolute bottom-0 left-0 m-2)" color="blue" v-model="selected" :options="layerOptions" />
    </div>
  </div>
</template>
<script setup>
const emit = defineEmits(["markerMove"]);
const props = defineProps({
  location: {
    type: Object,
  },
  schoolDistrict: {
    type: Array,
  },
});
const source = {
  type: "vector",
  url: "pmtiles://https://tiles.whatismyelevation.com/2024-school-districts.pmtiles",
  promoteId: "GEOID",
  id: "school_districts",
  maxzoom: 10,
};
const selected = ref("unified");
const layers = {
  unified: {
    lineLayer: "unified",
    labelLayer: "unified_names",
    labelField: "NAME",
    name: "Unified",
  },
  elementary: {
    lineLayer: "elementary",
    labelLayer: "elementary_names",
    labelField: "NAME",
    name: "Elementary",
  },
  secondary: {
    lineLayer: "secondary",
    labelLayer: "secondary_names",
    labelField: "NAME",
    name: "Secondary",
  },
};
const schoolsLayers = [
  {
    id: "schools-circle",
    type: "circle",
    source: "school_districts",
    "source-layer": "schools",
    paint: {
      "circle-color": "#1e86e9",
      "circle-opacity": 0.7,
      // interpolate from 0-3 based on zoom
      "circle-radius": ["interpolate", ["linear"], ["zoom"], 5, 0, 8, 1, 14, 3],
      "circle-stroke-width": 1,
      "circle-stroke-color": "rgba(255,255,255,0.5)",
    },
  },
  {
    id: "schools-label",
    type: "symbol",
    source: "school_districts",
    "source-layer": "schools",
    minzoom: 12,
    layout: {
      "text-font": ["Noto Sans Regular"],
      "text-field": ["get", "NAME"],
      "text-size": 13,
      "text-justify": "auto",
      "text-variable-anchor": ["top", "bottom"],
      "text-radial-offset": 0.75,
      "text-max-width": 8,
    },
    paint: {
      "text-color": "#1e86e9",
      "text-halo-color": "rgba(255,255,255,0.5)",
      "text-halo-width": 1,
    },
  },
];
const layerOptions = Object.entries(layers).map(([key, value]) => ({
  value: key,
  label: value.name,
}));
const selectedLayer = computed(() => layers[selected.value] || layers.unified);
const selectedDistrict = computed(() => {
  if (!props.schoolDistrict) {
    return null;
  }
  return props.schoolDistrict.find((d) => d.type === selected.value) || props.schoolDistrict[0];
});
watchEffect(() => {
  if (props.schoolDistrict?.length > 0) {
    selected.value = props.schoolDistrict[0]?.type;
  }
});

const hasLocation = computed(() => {
  return isNumber(props.location?.latitude) && isNumber(props.location?.longitude);
});
</script>
